var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallCtaBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.3,
    fill: "#EEF5FE",
    stroke: "#2355FC",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.642 19.376v1.957a1.303 1.303 0 01-1.424 1.305 12.95 12.95 0 01-5.641-2.003 12.731 12.731 0 01-3.922-3.914 12.893 12.893 0 01-2.007-5.656 1.303 1.303 0 011.3-1.422h1.962a1.309 1.309 0 011.307 1.122c.083.626.236 1.241.458 1.833a1.303 1.303 0 01-.295 1.376l-.83.829a10.448 10.448 0 003.922 3.914l.83-.828a1.308 1.308 0 011.38-.294c.593.22 1.209.374 1.836.457a1.308 1.308 0 011.124 1.324z",
    fill: "#2355FC"
  })));
}

export default SvgCallCtaBlue;